
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke-width":"1.6","d":"M15.62 7.82v17.5"}}),_c('path',{attrs:{"stroke-width":"1.2","d":"M6.88 9.69a17.74 17.74 0 013.12.63 18 18 0 013.12 1.25M13.12 19.37A18.85 18.85 0 0010 18.12a18.58 18.58 0 00-3.12-.62"}}),_c('path',{attrs:{"stroke-width":"1.6","d":"M15.62 7.82a19.37 19.37 0 0111.26-3.13v17.5a19.37 19.37 0 00-11.26 3.13 19.31 19.31 0 00-11.24-3.13V4.69a19.31 19.31 0 0111.24 3.13z"}}),_c('path',{attrs:{"stroke-width":"1.2","d":"M18.12 11.57a18.48 18.48 0 013.13-1.25 17.66 17.66 0 013.13-.63M24.38 17.5a18.48 18.48 0 00-3.13.62 19.36 19.36 0 00-3.13 1.25M13.12 15.62A18.85 18.85 0 0010 14.37a18.58 18.58 0 00-3.12-.62M24.38 13.75a18.48 18.48 0 00-3.13.62 19.36 19.36 0 00-3.13 1.25"}})])])
          )
        }
      }
    